import * as Cookies from "js-cookie";
import Player from '@vimeo/player';
import { ModalManager, DialogAdapter, ModalPriority } from "./modal_manager";

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.querySelector(".ad-modal");
  if (!modal) return;

  const adId = modal.dataset.advertisementId;
  if (!adId) return;

  function buildCookieName(adId) {
    return `ad_modal_suppression_${adId}`;
  }

  // 広告モーダル表示抑制有効期限: `次回から表示しない` をチェックした場合は365日間、しなかった場合は7日間
  const PERMANENT_SUPPRESSION_DAYS = 365;  // Chromiumの保存上限(400日)を超えない範囲での実質的な永久値
  const TEMPORARY_SUPPRESSION_DAYS = 7;    // 広告モーダル仕様で定めた暫定日数

  function calculateSuppressionExpires(isPermanent) {
    return isPermanent ? PERMANENT_SUPPRESSION_DAYS : TEMPORARY_SUPPRESSION_DAYS;
  }

  function bakeAdModalSuppressionCookie(adId, expires) {
    const cookieName = buildCookieName(adId);
    const value = (expires === PERMANENT_SUPPRESSION_DAYS) ? "never" : "later";

    Cookies.set(cookieName, value, { expires, sameSite: "Lax" });
  }

  // 有効な表示抑制cookieがあれば表示しない
  if (Cookies.get(buildCookieName(adId))) return;

  // モーダルを表示（ModalManager経由でキューイング）
  ModalManager.enqueue(new DialogAdapter(modal, ModalPriority.ADVERTISEMENT));

  // Vimeo Player control
  const iframe = modal.querySelector('iframe.ad-modal-video[id^="ad-video-"]');
  if (iframe) {
    const player = new Player(iframe);
    player.ready()
      // mute (auto play policy based)
      .then(() => player.setMuted(true))
      // auto play
      .then(() => player.play())
      // error handling
      .catch(error => {
        switch (error.name) {
          case 'NotAllowedError':
            // [iOS] auto play failed due to low power mode, etc.
            // reset to thumbnail state from playing state (loading displayed)
            player.pause().then(() => player.unload());
            break;
          default:
            // other errors
            break;
        }
      });
  }

  // Prevent ESC key input (and modal exit)
  modal.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') event.preventDefault();
  });

  // ✗ボタンクリックで閉じる
  const closeButton = modal.querySelector(".ad-modal-close");
  closeButton?.addEventListener("click", () => {
    modal.close();
  });

  // close時にcookieに書き込む
  const doNotShowAgainCheckbox = modal.querySelector(".ad-modal-do-not-show-again");
  modal.addEventListener("close", () => {
    const isPermanent = doNotShowAgainCheckbox?.checked ?? false;
    const expires = calculateSuppressionExpires(isPermanent);

    bakeAdModalSuppressionCookie(adId, expires);
  });
});

